import useRiskAssessment from "@root/hooks/useRiskAssessments";
import React, { createContext, useContext, ReactNode } from "react";

const RiskAssessmentContext = createContext<any>(undefined);

interface RiskAssessmentContextProviderProps {
  children: ReactNode;
}

export const RiskAssessmentContextProvider: React.FC<
  RiskAssessmentContextProviderProps
> = ({ children }) => {
  const data = useRiskAssessment();
  return (
    <RiskAssessmentContext.Provider value={data}>
      {children}
    </RiskAssessmentContext.Provider>
  );
};

export const useRiskAssessmentContext = () => {
  const context = useContext(RiskAssessmentContext);
  return context;
};
